<template>
  <div class="modal" v-show="show">
    <div class="modal-back" @click="hideModal"></div>
    <div class="modal-ctx">
      <div class="ctx-box" :style="{ width }">
        <div class="modal-ti" v-if="title">{{ title }}</div>
        <div class="modal-content">
          <slot></slot>
        </div>
        <div class="modal-btn">
          <a-button @click="hideModal">取消</a-button>
          <a-button type="primary" @click="confirm" class="confirm-btn">确定</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal",
  props: {
    title: String,
    hold: Boolean,
    show: Boolean,
    width: String,
  },
  data() {
    return {};
  },
  methods: {
    hideModal() {
      this.$emit("update:show", false);
    },
    confirm() {
      this.$emit("confirm");
      !this.hold && this.$emit("update:show", false);
    },
  },
};
</script>

<style scoped lang="less">
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  overflow: hidden;
}
.modal-ctx,
.modal-back {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.modal-back {
  background-color: rgba(0, 0, 0, 0.75);
}
.modal-ctx {
  padding: 20px;
  text-align: center;
  overflow: auto;
  &::before {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }
}
.ctx-box {
  display: inline-block;
  vertical-align: middle;
  width: 800px;
  padding: 10px 20px;
  background-color: #fff;
}
.modal-ti {
  padding: 5px 10px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
}
.modal-content {
  margin-top: 10px;
  padding: 10px;
  text-align: left;
}
.modal-btn {
  padding: 10px 20px;
  text-align: center;
}
.confirm-btn {
    margin-left: 16px;
}
</style>
